export default [
  {
    path: "*",
    meta: {
      name: "",
      requiresAuth: true,
    },
    redirect: {
      path: "/",
    },
  },
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/otp",
    name: "otp",
    component: () => import("@/views/OtpValidate.vue"),
  },
  {
    path: "/passwordentry",
    name: "tab",
    component: () => import("@/views/SetPassword/PasswordEntry.vue"),
  },
  {
    path: "/receipt",
    meta: {
      name: "receipt",
      requiresAuth: true,
    },
    component: () => import("@/views/Receipt.vue"),
  },
  {
    path: "/accountsummary",
    meta: { name: "accountsummary", requiresAuth: true },
    component: () => import("@/views/AccountSummary.vue"),
  },
  {
    path: "/clarificationText",
    name: "clarificationText",
    component: () => import("@/views/afterLoginApproval/ClarificationText.vue"),
  },
  {
    path: "/explicitPermissionText",
    name: "explicitPermissionText",
    component: () => import("@/views/afterLoginApproval/ExplicitPermissionText.vue"),
  },
  {
    path: "/profile",
    meta: {
      name: "profile",
      requiresAuth: true,
    },
    component: () => import("@/views/Profile.vue"),
  },
  {
    path: "/eft",
    meta: { name: "eft", requiresAuth: true },
    component: () => import("@/views/Eft.vue"),
  },
];
